import { useSelector } from 'react-redux';

import { selectAppliedAddOns } from '@lib/core/retailers/selectors/retailerLocation';

export const useAddons = () => {
  return useSelector(selectAppliedAddOns);
};
